<div class="employee-details-salary-history">
	<div class="employee-details-salary-history__header">
		<h3 class="employee-details-salary-history__title">Histórico salarial</h3>
		<p class="employee-details-salary-history__subtitle">
			Evolução de função e remuneração ao longo do vínculo
		</p>
	</div>

	<ng-container *ngIf="isLoading; else contentBlock">
		<div class="employee-details-salary-history__loading">
			<span class="spinner-border text-primary spinner-border-sm"></span>
			<span>Carregando histórico salarial...</span>
		</div>
	</ng-container>

	<ng-template #contentBlock>
		<ng-container *ngIf="!hasLoadError; else loadErrorBlock">
			<div class="salary-history-summary" *ngIf="summaryCards.length">
				<div
					class="salary-history-summary__card"
					*ngFor="let card of summaryCards"
					[attr.data-tone]="card.iconTone"
				>
					<div class="salary-history-summary__text">
						<small>{{ card.title }}</small>
						<strong>{{ card.value }}</strong>
						<span>{{ card.subtitle }}</span>
					</div>
					<span class="salary-history-summary__icon" aria-hidden="true">
						<i class="feather" [ngClass]="'icon-' + card.icon"></i>
					</span>
				</div>
			</div>

			<section class="salary-history-section-table" *ngIf="allItems.length > 0; else emptyTable">
				<div class="card card-fit card-table shadow mt-1 mb-0">
					<div class="card-body card-table p-0">
						<div class="table-responsive">
							<table class="salary-history-table">
								<thead>
									<tr>
										<th class="salary-history-table__col-date">
											<div class="salary-history-column-filter-header">
												<div class="salary-history-column-filter-title-row">
													<button type="button" class="salary-history-sort-btn" (click)="toggleSort('movementDate')">
														DATA
														<i class="feather" [ngClass]="sortIcon('movementDate')"></i>
													</button>
													<button
														type="button"
														class="btn btn-link salary-history-column-filter-toggle"
														[class.active]="columnFilterVisibility.movementDate || !!columnQueries.movementDate"
														(click)="toggleColumnFilter('movementDate'); $event.stopPropagation()"
													>
														<i class="feather icon-search"></i>
													</button>
												</div>
												<div class="salary-history-column-filter-input" *ngIf="columnFilterVisibility.movementDate">
													<input
														type="text"
														class="form-control form-control-sm"
														placeholder="dd/mm/aaaa"
														[(ngModel)]="columnQueries.movementDate"
														(input)="onColumnFilterChange()"
														(click)="$event.stopPropagation()"
													/>
													<button
														*ngIf="columnQueries.movementDate"
														type="button"
														class="btn btn-link salary-history-column-filter-clear"
														(click)="clearColumnFilter('movementDate'); $event.stopPropagation()"
													>
														<i class="feather icon-x"></i>
													</button>
												</div>
											</div>
										</th>
										<th class="salary-history-table__col-motivation">
											<button type="button" class="salary-history-sort-btn" (click)="toggleSort('changeType')">
												MOVIMENTAÇÃO
												<i class="feather" [ngClass]="sortIcon('changeType')"></i>
											</button>
										</th>
										<th class="salary-history-table__col-title">
											<div class="salary-history-column-filter-header">
												<div class="salary-history-column-filter-title-row">
													<button type="button" class="salary-history-sort-btn" (click)="toggleSort('jobTitleName')">
														FUNÇÃO
														<i class="feather" [ngClass]="sortIcon('jobTitleName')"></i>
													</button>
													<button
														type="button"
														class="btn btn-link salary-history-column-filter-toggle"
														[class.active]="columnFilterVisibility.jobTitleName || !!columnQueries.jobTitleName"
														(click)="toggleColumnFilter('jobTitleName'); $event.stopPropagation()"
													>
														<i class="feather icon-search"></i>
													</button>
												</div>
												<div class="salary-history-column-filter-input" *ngIf="columnFilterVisibility.jobTitleName">
													<input
														type="text"
														class="form-control form-control-sm"
														placeholder="Buscar"
														[(ngModel)]="columnQueries.jobTitleName"
														(input)="onColumnFilterChange()"
														(click)="$event.stopPropagation()"
													/>
													<button
														*ngIf="columnQueries.jobTitleName"
														type="button"
														class="btn btn-link salary-history-column-filter-clear"
														(click)="clearColumnFilter('jobTitleName'); $event.stopPropagation()"
													>
														<i class="feather icon-x"></i>
													</button>
												</div>
											</div>
										</th>
										<th class="salary-history-table__col-cost-center">
											<div class="salary-history-column-filter-header">
												<div class="salary-history-column-filter-title-row">
													<button type="button" class="salary-history-sort-btn" (click)="toggleSort('costCenterName')">
														CENTRO DE CUSTO
														<i class="feather" [ngClass]="sortIcon('costCenterName')"></i>
													</button>
													<button
														type="button"
														class="btn btn-link salary-history-column-filter-toggle"
														[class.active]="columnFilterVisibility.costCenterName || !!columnQueries.costCenterName"
														(click)="toggleColumnFilter('costCenterName'); $event.stopPropagation()"
													>
														<i class="feather icon-search"></i>
													</button>
												</div>
												<div class="salary-history-column-filter-input" *ngIf="columnFilterVisibility.costCenterName">
													<input
														type="text"
														class="form-control form-control-sm"
														placeholder="Buscar"
														[(ngModel)]="columnQueries.costCenterName"
														(input)="onColumnFilterChange()"
														(click)="$event.stopPropagation()"
													/>
													<button
														*ngIf="columnQueries.costCenterName"
														type="button"
														class="btn btn-link salary-history-column-filter-clear"
														(click)="clearColumnFilter('costCenterName'); $event.stopPropagation()"
													>
														<i class="feather icon-x"></i>
													</button>
												</div>
											</div>
										</th>
										<th class="salary-history-table__col-salary">
											<button type="button" class="salary-history-sort-btn" (click)="toggleSort('salary')">
												SALÁRIO
												<i class="feather" [ngClass]="sortIcon('salary')"></i>
											</button>
										</th>
										<th class="salary-history-table__col-variation">
											<button type="button" class="salary-history-sort-btn" (click)="toggleSort('variation')">
												VARIAÇÃO
												<i class="feather" [ngClass]="sortIcon('variation')"></i>
											</button>
										</th>
									</tr>
								</thead>
								<tbody>
									<tr *ngFor="let row of pagedItems">
										<td class="salary-history-table__col-date">{{ row.movementDate | date: 'dd/MM/yyyy' }}</td>
										<td class="salary-history-table__col-motivation">
											<span class="motivation-badge">{{ row.changeType || '—' }}</span>
										</td>
										<td class="salary-history-table__col-title" [title]="row.jobTitleName || ''">
											{{ row.jobTitleName || '—' }}
										</td>
										<td class="salary-history-table__col-cost-center" [title]="row.costCenterName || ''">
											{{ row.costCenterName || '—' }}
										</td>
										<td class="salary-history-table__col-salary">{{ formatSalary(row.salary) }}</td>
										<td class="salary-history-table__col-variation">
											<span class="variation-badge" [ngClass]="variationClass(row.variation)">
												<ng-container *ngIf="row.variation !== null && row.variation !== undefined; else admissionVariation">
													<span class="variation-badge__arrow" *ngIf="row.variation > 0">↑</span>
													<span class="variation-badge__arrow" *ngIf="row.variation < 0">↓</span>
													{{ formatVariationValue(row.variation) }}
												</ng-container>
												<ng-template #admissionVariation>Admissão</ng-template>
											</span>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div class="card-footer">
							<app-paginator
								type="squared"
								class="flex-1"
								[count]="count"
								[filter]="queryParams.filter"
								[queryParams]="queryParams"
								[optionSize]="[10, 30, 50]"
								[showDisplayedCount]="true"
								(query)="onPaginatorQuery()"
							>
							</app-paginator>
						</div>
					</div>
				</div>
			</section>

			<ng-template #emptyTable>
				<div class="employee-details-salary-history__empty">
					Ainda não há movimentações de histórico salarial para este colaborador.
				</div>
			</ng-template>
		</ng-container>

		<ng-template #loadErrorBlock>
			<div class="employee-details-salary-history__empty employee-details-salary-history__empty--error">
				<p class="mb-1">Não foi possível carregar o histórico salarial.</p>
				<button type="button" class="btn btn-outline-primary btn-sm" (click)="retryLoad()">
					Tentar novamente
				</button>
			</div>
		</ng-template>
	</ng-template>
</div>
